import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { FaRegAddressCard } from "react-icons/fa";
import { ThemeColor } from "../../../Theme/theme";

import { nsdlRequest, travelRedirect } from "../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";

const Travel = () => {
  const [btnLoading, setBtnLoading] = useState({
    generateNewPanReqest: false,
    generateCorrectionRequest: false,
  });
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleRedirect = () => {
    travelRedirect()
      .then((res) => {
        if (res.status) {
          window.open(res.redirect_url, "_blank");
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    dispatch(setselectedTab("6"));
    // if (!memberServices.includes("19")) {
    //   navigate("/not-Available");
    // }
  }, []);
  return (
    <>
      <div className="grid grid-cols-1 gap-10 place-items-center">
        <section class="container w-full">
          <div class="card w-full">
            <div class="content">
              <div class="">
                <div className="flex justify-end items-center mt-6">
                  <Button
                    // loading={btnLoading.generateNewPanReqest}
                    onClick={() => handleRedirect()}
                    className="bg-primary outline-none border-none text-white hover:outline-none focus:border-none"
                  >
                    Redirect To Travel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div></div>
      </div>
    </>
  );
};

export default Travel;
